import { render, staticRenderFns } from "./CustomerFormWrapper.vue?vue&type=template&id=6276ff0c&"
import script from "./CustomerFormWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomerFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports